import React, {useEffect} from "react";
import {ensureResultButtonsClickable, navigateSafely} from "../../services/PayGuard";
import {Image} from "react-bootstrap";

import nobankPig from '../../assets/img/nobankPig.png'
import {useLocation, useNavigate} from "react-router-dom";
import withAuth from '../../auth/UserRouteAuth'
import {useTranslation} from "react-i18next";
import TagManager from 'react-gtm-module';
import axios from "../../services/axiosInstance";

import Lottie from "lottie-react";
import loading from "../../assets/motion/fruitLoading.json";
import useTheme from "../../components/web/layoutscommon/DarkModeStorage";
import "../../css/web/UserPageRenew.css";

function UserPayWaitPg() {

    const { t } = useTranslation();
    const location = useLocation();
    /*
     * 새로고침(F5)하면 navigate 로 실어보낸 state 가 사라진다.
     * 예전에는 여기서 곧바로 TypeError 가 나 화면이 하얗게 비었다.
     * (UserPayFailedPg 는 이미 이렇게 막고 있어 규격을 맞춘다)
     */
    const data = location.state?.data;
    const navigate = useNavigate();
    const [theme] = useTheme();

    /*
     * 결제 직후 이 화면으로 넘어오면 버튼이 먹통이 되는 일이 있었다.
     * 페이팔이 <body> 에 남긴 덮개가 원인인데, 라우팅으로는 지워지지 않아
     * 새로고침해야 풀렸다. 화면에 들어올 때 한 번 치우고 확인한다.
     */
    useEffect(() => ensureResultButtonsClickable(), []);

    const orderDetailPgMove = (ordNum) => () => {
        navigateSafely(navigate, `/UserMyOrderPg/${ordNum}`);
    };

    // Btorage 서버저장
    useEffect(() => {
        if (data) {
            const clickId = localStorage.getItem('bt_sub1');
            const adChannel = localStorage.getItem('bt_sub2');

            if (clickId && adChannel) {
                let channelType;
                let platformType;

                // ChannelType 추출
                if (adChannel.includes("google")) channelType = '1'
                else if (adChannel.includes("youtube")) channelType = '2'
                else if (adChannel.includes("facebook")) channelType = '3'
                else if (adChannel.includes("instagram")) channelType = '4'
                else if (adChannel.includes("naver")) channelType = '5'
                else if (adChannel.includes("tiktok")) channelType = '6'
                else if (adChannel.includes("threads")) channelType = '7'
                else if (adChannel.includes("twitter")) channelType = '8'
                else if (adChannel.includes("gpt")) channelType = '9'
                else if (adChannel.includes("gemini")) channelType = '10'
                else if (adChannel.includes("community")) channelType = '11'

                // PlatformType 추출(2면 모바일웹 : 웹)
                platformType = window.navigator.userAgent.includes('Mobi') ? '2' : '1';

                axios({
                    method: 'post',
                    url: '/channelLog/saveAdData',
                    data: {
                        clickId:clickId,
                        eventType: '1', // Purchase
                        channelType: channelType,
                        platformType: platformType,
                        paymentPrice: data.lastPrice
                    },
                }).then((res) => {
                    localStorage.removeItem('bt_sub1');
                    localStorage.removeItem('bt_sub2');
                    console.log("광고수익 기록성공 : ", res.data);
                }).catch((err) => {
                    console.log("광고수익 기록실패 : ", err)
                })
            }
        }
    }, [data]);

    // 네이버 저장
    useEffect(() => {
        if (!data) return;

        // 스크립트 로딩
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = '//wcs.naver.net/wcslog.js';
        document.head.appendChild(script);

        script.onload = () => {
            if (!window.wcs_add) window.wcs_add = {};
            window.wcs_add["wa"] = "s_29feb3eace6a"; // 네이버공통키

            const _conv = {
                type: 'purchase', // 필수
                value: String(data.lastPrice), // 총 결제 금액
                id: String(data.orderNumber), // 주문 번호
            };

            if (window.wcs?.trans) {
                window.wcs.trans(_conv);
                console.log("Naver 전환스크립트 전송성공", _conv);
            }
        };
    }, [data]);

    const payWayLabel = (payWay) => (
        payWay === "PM00" ? t(`modNoBank`) :
            payWay === "PM01" ? "Paypal" :
                payWay === "PM02" ? "WechatPay" :
                    payWay === "PM03" ? "AliPay" :
                        payWay === "PM04" ? t(`modPt`) :
                            payWay === "PM05" ? t(`modDep`) :
                                payWay === "PM06" ? "BtoragePay(Global)" :
                                    payWay === "PM07" ? "BtoragePay(Korean)" :
                                        payWay === "PM08" ? "GlobalCard" :
                                            payWay === "PM09" ? "KoreanPay" : null
    );

    return (
        <div className="up-scope up-page" data-theme={theme}>
            <div className="up-result-wrap">
                <div className="up-result">
                    <div className="up-card up-result-card">
                        <div className="up-result-hero">
                            <Lottie animationData={loading} loop autoplay className="wd-300 ht-150 opa08"/>
                            <p style={{fontSize: "18px", fontFamily: "'LINESeedKR-Bd', sans-serif"}}>
                                {/*결제신청이 완료되었습니다*/}
                                {data?.payWay === "PM01" ? t('pwHeader4') : t(`pwCont1`)}
                            </p>
                            <span style={{fontSize: "14px", color: "var(--up-text-sub)", textAlign: "center"}}>
                                {/*원활한 확인을 위해 24시간 내에 입금해주세요*/}
                                {data?.payWay === "PM01" ? t('pwCont3') : t(`pwCont2`)}
                            </span>
                        </div>
                        <div className="up-result-rows">
                            <div className="up-result-row">
                                <span className="k">{t(`myTab1`)}</span>
                                <span className="v">{data && data?.orderNumber}</span>
                            </div>
                            {/*payWay가 PM00이면 무통장입금, PM02면 위챗, PM03이면 알리 하드코딩*/}
                            <div className="up-result-row">
                                <span className="k">{t(`modPty`)}</span>
                                <span className="v">{data && payWayLabel(data?.payWay)}</span>
                            </div>

                            {data && data?.payWay === "PM00" ?
                                <div className="up-result-row">
                                    <span className="k">{t(`pwHeader1`)}</span>
                                    <span className="v">{t(`pwAcctNm`)}</span>
                                </div>
                                :
                                null
                            }
                            {/*payWay가 PM00이면 신한계좌번호, PM02면 위챗ID, PM03이면 알리ID*/}
                            {data && data?.payWay === "PM00" ?
                                <div className="up-result-row">
                                    <span className="k">{t(`pwHeader2`)}</span>
                                    <span className="v">{t(`pwAcctNum`)}</span>
                                </div>
                                :
                                data?.payWay === "PM02" ?
                                    <div className="up-result-row">
                                        <span className="k">Weixin ID</span>
                                        <span className="v">lfamily-help</span>
                                    </div>
                                    :
                                    data?.payWay === "PM03" ?
                                        <div className="up-result-row">
                                            <span className="k">{t(`pwHeader2`)}</span>
                                            <span className="v">13165072023</span>
                                        </div>
                                        :
                                        null
                            }
                            <div className="up-result-row">
                                <span className="k">{t(`pcWon`)}</span> {/*최종원화금액*/}
                                <span className="v">₩ {data && data?.lastPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
                            </div>

                            {/*payWay가 PM01(페이팔), PM02(위챗), PM03(알리), PM06(비토리지페이) PM08(GlobalCard)일 경우 출력*/}
                            {data && (data?.payWay === "PM01" || data?.payWay === "PM02" || data?.payWay === "PM03" ||
                                data?.payWay === "PM06" || data?.payWay === "PM08") ?
                                <div className="up-result-row">
                                    <span className="k">
                                        {(data?.payWay === "PM02" || data?.payWay === "PM03") ? t(`pwCny`) : t(`pcFor`)}
                                    </span>
                                    <span className="v">{data && data?.lastForPrice} {data && data?.forCurrency}</span>
                                </div>
                                :
                                null
                            }
                        </div>
                    </div>
                    <div className="up-btn-row">
                        <button onClick={() => navigateSafely(navigate, "/UserMyPg")} className="up-btn-ghost" style={{height: "50px", fontSize: "16px", cursor: "pointer"}}>
                            {t(`hdMypg`)}
                        </button>
                        <button onClick={orderDetailPgMove(data?.orderNumber)} className="up-btn-primary"
                                style={{height: "50px", fontSize: "16px", cursor: "pointer"}}
                                disabled={!data?.orderNumber}>
                            {t(`modHeader`)}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withAuth(UserPayWaitPg)
